import { useStorage } from '@vueuse/core'
import { createI18n as createClientI18n } from 'vue-i18n'
/**
 * messages are generated using vite-plugin-i18n
 * each .json files located in the ./src/locales are registered in messages
 * @see https://github.com/intlify/vite-plugin-vue-i18n
 */
import messages from '@intlify/unplugin-vue-i18n/messages'
import { getDefaultLanguage } from '/@src/utils'

export function createI18n() {
  const defaultLanguage = getDefaultLanguage()
  const defaultLocale = useStorage('locale', defaultLanguage)
  let language = defaultLocale.value as string
  // 默认使用中文
  switch (language) {
    case 'zh':
    case 'zh-CN':
      language = 'zh-CN'
      break
    case 'en':
    case 'en-US':
      language = 'en'
      break
    default:
      language = 'zh-CN'
      break
  }
  const i18n = createClientI18n({
    locale: language,
    messages,
  })

  return i18n
}
